import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ComponentSwitcherDirective } from '@anecdotes/design-system/component-switcher';
import { ModalWindow } from '../../models';

@Component({
  selector: 'app-modal-template-host',
  templateUrl: './modal-template-host.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModalTemplateHostComponent implements OnInit {
  templateModalWindow$: Observable<ModalWindow>;

  constructor(private componentsSwitcher: ComponentSwitcherDirective) {}

  ngOnInit(): void {
    this.templateModalWindow$ = this.componentsSwitcher.sharedContext$.pipe(
      map((ctx) => ctx.templateModalWindow as ModalWindow<any>)
    );
  }
}
